import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

// @ts-expect-error
const fullConfig = resolveConfig(tailwindConfig);

export const brandDarkBlue = fullConfig.theme?.colors?.['brand-dark-blue'] as string;
